import React from 'react';
import {
  Link,
} from 'react-router-dom';
import { IoIosArrowForward } from 'react-icons/io';
import aboutImg from '../../../asset/NavSidebar/about.png';
import flowImg from '../../../asset/NavSidebar/flow.png';
import questionImg from '../../../asset/NavSidebar/question.png';
import contactImg from '../../../asset/NavSidebar/contact.png';

const NavSidebar = () => (
  <>
    <div className="navSiderbar" style={{ background: 'white' }}>
      <br />
      <div className="item d-block">
        <Link
          className="d-block px-2 py-1 my-1"
          to="/subscription"
          style={{
            background: 'rgb(44,80,116)',
            color: 'white',
            lineHeight: '2',
            textDecoration: 'none',
          }}
        >
          定期便
          <IoIosArrowForward style={{ float: 'right', marginTop: '8px' }} />
        </Link>
        <Link
          className="d-block px-2 py-1 my-1"
          to="/single"
          style={{
            background: 'rgb(44,80,116)',
            color: 'white',
            lineHeight: '2',
            textDecoration: 'none',
          }}
        >
          単品
          <IoIosArrowForward style={{ float: 'right', marginTop: '8px' }} />
        </Link>
        <Link
          className="d-block px-2 py-1 my-1"
          to="/product"
          style={{
            background: 'white',
            color: 'rgb(44,80,116)',
            lineHeight: '2',
            textDecoration: 'none',
            borderBottom: 'solid 1px rgb(177,179,182)',
          }}
        >
          全ての商品
          <IoIosArrowForward style={{ float: 'right', marginTop: '8px' }} />
        </Link>
        <a
          className="d-block px-2 py-1 my-1"
          href="http://www.terra-coat.jp"
          target="_blank"
          rel="noreferrer"
          style={{
            background: 'white',
            color: 'rgb(44,80,116)',
            lineHeight: '2',
            textDecoration: 'none',
            borderBottom: 'solid 1px rgb(177,179,182)',
          }}
        >
          光触媒コーティングサービス
          <IoIosArrowForward style={{ float: 'right', marginTop: '8px' }} />
        </a>
      </div>
      <div className="siderbar-about my-5 mx-2">
        <Link to="/about">
          <img src={aboutImg} style={{ width: '100%' }} alt="Terraについて" />
        </Link>
      </div>
      <div className="siderbar-flow text-center my-5 mx-2">
        <Link
          to="/purchase"
          style={{
            color: 'rgb(44,80,116)',
            textDecoration: 'none',
          }}
        >
          <img src={flowImg} style={{ width: '100%', marginBottom: '1rem' }} alt="ご購入の流れ" />
          ご購入の流れ
        </Link>
      </div>
      <div className="siderbar-question text-center my-5 mx-2">
        <Link
          to="/faq"
          style={{
            color: 'rgb(44,80,116)',
            textDecoration: 'none',
          }}
        >
          <img src={questionImg} style={{ width: '100%', marginBottom: '1rem' }} alt="よくあるご質問" />
          よくあるご質問
        </Link>
      </div>
      <div className="siderbar-contact my-5 mx-2">
        <Link to="/contact">
          <img src={contactImg} style={{ width: '100%' }} alt="お問い合わせ" />
        </Link>
      </div>

    </div>
  </>
);
export default NavSidebar;
